import React from 'react';
import Header from '../components/Header';
import Product from '../components/Product';

function ProductPage() {

  return (
    <>
    <Header/>
    <Product/>
    </>
  )
}

export default ProductPage